export default [
  {
    path: '/client_order_details',
    name: 'HomeClientOrderDetails',
    component: () => import("@/_backoffice/_client_order/pages/ClientOrderHome.vue"),
    children: [
      {
        path: 'home',
        name: 'ClientOrderHome',
        component: () => import("@/_backoffice/_client_order/components/ClientOrderDetails.vue"),
      },
    ]
  },
  {
    path: '/unauthorized',
    name: 'UnauthorizedClientOrderDetails',
    component: () => import("@/_backoffice/_client_order/pages/ClientOrderUnauthorized.vue"),
  },
]
